import { IssuedConsumedRptConstants } from '../constants';
export function IssuedConsumedRpt(state = {}, action) {
    switch (action.type) {
        case IssuedConsumedRptConstants.LODING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case IssuedConsumedRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true,
            };
        case IssuedConsumedRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas,
                isDownload: state.isDownload == null ? 1 : state.isDownload + 1
            };
        case IssuedConsumedRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        case IssuedConsumedRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case IssuedConsumedRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case IssuedConsumedRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }
}